/**
 * Remoting XPAC API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CompanyType = 'crossPoint' | 'dealer' | 'installer' | 'retailer';

export const CompanyType = {
    CrossPoint: 'crossPoint' as CompanyType,
    Dealer: 'dealer' as CompanyType,
    Installer: 'installer' as CompanyType,
    Retailer: 'retailer' as CompanyType
};

